import { render, staticRenderFns } from "./GroupAttendanceForm.vue?vue&type=template&id=50b043ba&scoped=true&"
import script from "./GroupAttendanceForm.vue?vue&type=script&lang=js&"
export * from "./GroupAttendanceForm.vue?vue&type=script&lang=js&"
import style0 from "./GroupAttendanceForm.vue?vue&type=style&index=0&id=50b043ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b043ba",
  null
  
)

export default component.exports